//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'

export default {
  props: {
    text: {
      default: '隐藏'
    },
    tip: {
      default: '确认隐藏?'
    },
    loading: {
      default: false
    },
    visible: {
      default: false
    },
    trigger: {
      default: 'click'
    },
    owner: {
      default: () => ({
        loading: false
      })
    },
    className: {
      default: ''
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      currentLoading: this.loading
    }
  },
  watch: {
    loading: {
      handler (val) {
        this.currentLoading = val
      },
      immediate: true
    },
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    },
    'owner.loading': {
      handler (val) {
        // console.log('owner.loading', val)
        if (val && this.currentLoading) {
          this.close()
        }
      },
      immediate: true
    }
  },
  mounted () {

  },
  methods: {
    close () {
      this.currentLoading = false
      this.currentVisible = false
    }
  }
}
